import teamAvengers from '../assets/mocks/teamAvengers.json'
import axios from 'axios'
import store from '../store/store'
export default async () => {
  const { users } = teamAvengers
  const me = store.state.loggedInUser;
  const steps = [
    "create all users - attach ids",
    "make them employees",
    "get all levels",
    "add random levels to the users",
    "get all tariffs - billable && !fixedHours",
    "add random tariffs to the users",
    "create a team",
    "add all the users to the team"
  ]

  const mockTeam = (await axios.get('https://timenow-api-dev.geshdo.com/admin/teams')).data
    .find(team => team.name === 'Avengers')

  if (mockTeam) return console.log('Mock team already exists, stopping')

  // Step 1: create all users - attach ids
  console.log(users)
  console.log('Step 1: create all users - attach ids')
  await Promise.all(
    users.map(async (user) => {
      const responseId = (await axios({
        url: "https://timenow-api-dev.geshdo.com/admin/user",
        method: 'POST',
        data: user
      })).data
      user.userId = responseId;
      return user
    })
  )

  console.log(users)

  console.log('Step 2: Make the users Employees')
  // 
  await Promise.all(users.map(async (user) => {
    await axios({
      url: `https://timenow-api-dev.geshdo.com/admin/employees/${user.userId}`,
      method: 'POST',
      data: {
        employmentDate: "2021-07-01T00:00:00Z",
      }
    })
  }))

  console.log('Step 3: Get all levels')

  const allLevels = (await axios.get('https://timenow-api-dev.geshdo.com/metadata/levels')).data
  console.log(allLevels);

  console.log('Step 4: Add random levels to the users')
  await Promise.all(users.map(async (user) => {
    const randomLevel = allLevels[Math.floor(Math.random() * (allLevels.length - 1))]

    randomLevel.from = "2021-09-01T00:00:00Z"
    randomLevel.workPercentage = 100;
    randomLevel.levelId = randomLevel.id
 
    try {
      await axios({
        url: `https://timenow-api-dev.geshdo.com/admin/employees/${user.userId}/benefits/level`,
        method: 'PUT',
        data: randomLevel
      })
      console.log(`Added "${randomLevel.name}" to ${user.firstName}`)

    } catch {
      console.error(`Failed to add "${randomLevel.name}" to ${user.firstName}`)
    }
  }))

  console.log('Step 5 - Get all tariffs, billable & !fixedHours')
  const allTariffs = (await axios.get('https://timenow-api-dev.geshdo.com/tariffs/all')).data
    .filter((tariff) => !tariff.billable && !tariff.fixedHours)

  console.log(allTariffs);

  console.log('Step 6 - Add random tariffs to the users')
  await Promise.all(users.map(async (user) => {
    const randomTariff = allTariffs[Math.floor(Math.random() * (allTariffs.length - 1))]
    console.log(randomTariff);
    try {
      await axios({
        url: `https://timenow-api-dev.geshdo.com/admin/employees/${user.userId}/tariffs/${randomTariff.id}`,
        method: 'POST'
      })
      console.log(`Added "${randomTariff.name}" to ${user.firstName}`)
    } catch {
      console.error(`Failed to add "${randomTariff.name}" to ${user.firstName}`)
    }
  }))

  console.log('Step 7 - Create a team')
  const team = {
    from: "2021-09-01T00:00:00Z",
    name: "Avengers",
    teamManagerId: me.userId,
    directorId: me.userId
  }

  const createdTeam = (await axios({
    url: "https://timenow-api-dev.geshdo.com/admin/teams",
    method: 'POST',
    data: team
  })).data


  console.log('Step 8 - Add the users to the created team')
  await Promise.all(users.map(async (user) => {
    try {
      await axios({
        url: `https://timenow-api-dev.geshdo.com/admin/teams/${createdTeam.id}/members/${user.userId}`,
        method: 'PUT',
        data: {
          from: "2021-09-01T00:00:00Z"
        }
      })
      console.log(`Added "${user.firstName}" to ${createdTeam.name}`)
    } catch {
      console.error(`Failed to add "${user.firstName}" to ${createdTeam.name}`)
    }
  }))

  console.log('All steps completed congratulation, you are a proper team manager now 🎉')
}